var map = {
	"./acre.png": 27155,
	"./alagoas.png": 6768,
	"./amapa.png": 92664,
	"./amazonas.png": 21324,
	"./bahia.png": 29933,
	"./brasil.png": 88795,
	"./ceara.png": 69472,
	"./distrito-federal.png": 59472,
	"./espirito-santo.png": 12847,
	"./goias.png": 35877,
	"./maranhao.png": 12535,
	"./mato-grosso-sul.png": 11088,
	"./mato-grosso.png": 53727,
	"./minas-gerais.png": 94090,
	"./para.png": 71378,
	"./paraiba.png": 78294,
	"./parana.png": 87117,
	"./pernambuco.png": 64338,
	"./piaui.png": 36558,
	"./rio-grande-norte.png": 21567,
	"./rio-grande-sul.png": 40275,
	"./rio-janeiro.png": 59991,
	"./rondonia.png": 93022,
	"./roraima.png": 21951,
	"./santa-catarina.png": 39753,
	"./sao-paulo.png": 19519,
	"./sergipe.png": 55985,
	"./tocantins.png": 79785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37511;